"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
class Types {
    static AgreementsSchema;
    static GeneralSchema;
    static NetworkSchema;
    static CardSchema;
    static ContactSchema;
    static ProfileSchema;
    static SecuritySchema;
    static StateSchema;
    static UserSchema;
    static AppSchema;
    static PreferenceSchema;
    static VaultSchema;
    static MountedUserSchema;
    static Blank;
}
exports.Types = Types;
//# sourceMappingURL=index.js.map